
import Ontology from "../../../assets/outline/Ontology.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function OntologyIcon({ className, dataTestid = "OntologyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ontology data-testid={dataTestid} className={classes} {...rest} />
  );
}
